import React, { MouseEventHandler } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import { AnswerStatus } from "./helpers";
import Footer from "./Footer";

type Props = {
  answerStatus: number[];
  retry: MouseEventHandler;
  stopQuiz: MouseEventHandler;
};

const Result = ({ answerStatus, retry, stopQuiz }: Props) => {
  const correctCount = answerStatus.filter(
    (status) => status === AnswerStatus.correct
  ).length;

  const incorrectCount = answerStatus.filter(
    (status) => status === AnswerStatus.incorrect
  ).length;

  const totalCount = answerStatus.length;
  const skippedCount = totalCount - correctCount - incorrectCount;
  const score = correctCount / totalCount;

  return (
    <>
      <div className="container text-center">
        <div className="display-2 text-center mt-3">Result</div>
        <div className="row mt-5 mx-0 row justify-content-center">
          <div className="col-auto px-0 border">
            <Card
              icon="bi-check-circle-fill text-success"
              correctCount={correctCount}
              totalCount={totalCount}
              text="Correct"
            />
          </div>
          <div className="col-auto">
            <Card
              icon="bi-circle-fill text-warning"
              correctCount={skippedCount}
              totalCount={totalCount}
              text="Skipped"
            />
          </div>
          <div className="col-auto px-0">
            <Card
              icon="bi-x-circle-fill text-danger"
              correctCount={incorrectCount}
              totalCount={totalCount}
              text="Incorrect"
            />
          </div>
        </div>

        <div className="my-5">
          <p>{comment(score)}</p>
        </div>

        <div className="row">
          <div className="d-flex justify-content-center gap-4">
            <button type="button" className="btn btn-primary" onClick={retry}>
              <span className="bi bi-arrow-clockwise"></span>
              &nbsp;&nbsp; Retry quiz
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={stopQuiz}
            >
              <span className="bi bi-house"></span>
              &nbsp;&nbsp;Return to Home
            </button>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

type CardProps = {
  icon: string;
  correctCount: number;
  totalCount: number;
  text: string;
};

const Card = ({ icon, correctCount, totalCount, text }: CardProps) => {
  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title my-1">
          <i className={"bi " + icon + " me-2"}></i>
          {correctCount} / {totalCount}
        </h5>
        <p className="card-text text-secondary">{text}</p>
      </div>
    </div>
  );
};

const comment = (score: number) => {
  if (score <= 0.1) {
    return "Don't be discouraged! Everyone has to start somewhere. Keep practicing, and you'll improve quickly!";
  }
  if (score <= 0.2) {
    return "You're making progress! With a bit more practice, you'll see better results next time!";
  }
  if (score <= 0.3) {
    return "Keep going! You're on the right track. With continued effort, you'll master C++ in no time!";
  }
  if (score <= 0.4) {
    return "Not bad at all! With a little more study, you'll be even better!";
  }
  if (score <= 0.5) {
    return "Halfway there! Keep up the good work, and you'll soon be a C++ pro!";
  }
  if (score <= 0.6) {
    return "Well done! You're really getting the hang of C++ programming!";
  }
  if (score <= 0.7) {
    return "Great job! You have a solid understanding of C++ concepts!";
  }
  if (score <= 0.8) {
    return "Fantastic! You're really mastering C++ programming!";
  }
  if (score <= 0.9) {
    return "Excellent work! You're a C++ expert in the making!";
  }
  return "Perfect score! Congratulations, you're a C++ wizard!";
};

export default Result;
